export default __webpack_public_path__ + "static/media/travel.5d4593c4.jpg";